<template>
  <div class="shipping-cooperate">
    <el-card style="margin-bottom: 16px">
      <div style="display: flex; align-items: center">
        <el-button
          style="margin-right: 8px"
          type="success"
          size="small"
          @click="handleOutput"
        >
          导出</el-button
        >
        <el-upload
          ref="pickingUpload"
          :show-file-list="false"
          :data="{ origin_id: originId }"
          :auto-upload="true"
          :limit="1"
          :on-success="handleSuccess"
          :on-error="handleError"
          :before-upload="handleBeforeUpload"
          :disabled="loadingUpload"
          name="excel"
          :action="action"
          accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          with-credentials
        >
          <el-button
            slot="trigger"
            :loading="loadingUpload"
            type="primary"
            size="small"
          >
            物流合作导入
          </el-button>
        </el-upload>
        <el-button
          style="margin-left: 8px"
          type="primary"
          size="small"
          @click="changeLogShow = true"
        >
          修改日志</el-button
        >
      </div>
    </el-card>
    <el-card>
      <el-table border stripe :data="list">
        <el-table-column
          v-for="header in headerRows"
          :key="header.label"
          :label="header.label"
          :prop="header.prop"
        />
      </el-table>
      <el-pagination
        :total="total"
        :current-page="pageIndex"
        :page-size="pageSize"
        :page-sizes="[100, 200, 300, 400, 1000]"
        style="text-align: center; margin-top: 10px"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleChangePage"
        @size-change="handleChangePageSize"
      ></el-pagination>
    </el-card>

    <ChangeLogDialog
      v-model="changeLogShow"
      :origin-id="originId"
      type="cooperate"
    />
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

import { getWavePickingShippingCooperateList } from "@/controller/expressOptimization3041.js";
import ChangeLogDialog from "./ChangeLogDialog.vue";
import { downloadByUrl } from "@/utils/export.js";

export default {
  name: "ShippingCooperate",
  components: { ChangeLogDialog },
  props: {
    originId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      headerRows: [],
      list: [],
      pageIndex: 1,
      pageSize: 100,
      total: 0,
      loadingUpload: false,
      changeLogShow: false,
      action: `${apiBaseURL}/erp/WavePickingShipping/importWavePickingShippingCooperate`,
    };
  },
  mounted() {
    this.getWavePickingShippingCooperateList();
  },
  methods: {
    handleChangePage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getWavePickingShippingCooperateList();
    },
    handleChangePageSize(pageSize) {
      this.pageSize = pageSize;
      this.getWavePickingShippingCooperateList();
    },
    handleSuccess(res) {
      this.$refs.pickingUpload.clearFiles();
      this.loadingUpload = false;
      if (res.code !== 200) {
        this.$message.error(res.msg);
      } else if (res.data.file) {
        this.$message.error("导入失败");
        downloadByUrl(res.data.file);
      } else {
        this.$message.success("导入成功");
        this.getWavePickingShippingCooperateList();
      }
    },
    handleError(err) {
      this.$refs.pickingUpload.clearFiles();
      this.loadingUpload = false;
      this.$message.error(err);
    },
    handleBeforeUpload(file) {
      console.log("file", file);
      const suffixList = [".csv", ".xlsx", ".xls"];
      const isExcel = suffixList.some((suffix) => file.name.endsWith(suffix));
      if (!isExcel) {
        this.$message.info(
          `文件类型错误，请重新选择，仅支持${suffixList.join(",")}格式`
        );
        return;
      }
      this.loadingUpload = true;
    },
    async handleOutput() {
      const file = await this.getWavePickingShippingCooperateList({
        isExcel: 1,
      });
      if (file) {
        downloadByUrl(file);
      }
    },
    async getWavePickingShippingCooperateList(params) {
      try {
        const { isExcel = 0 } = params || {};
        const { list, total, file } = await getWavePickingShippingCooperateList(
          {
            origin_id: this.originId,
            page: this.pageIndex,
            pageSize: this.pageSize,
            is_excel: isExcel,
          }
        );
        if (!isExcel) {
          this.total = total;
          if (list && list.length) {
            const { shippingCompanyStatus } = list[0];
            this.headerRows = shippingCompanyStatus.map((item) => {
              return {
                label: item.shipping_company,
                prop: item.shipping_company,
              };
            });
            this.headerRows.unshift({
              label: "省/市/区（县）",
              prop: "whole_name",
            });
            this.list = list.map((item) => {
              const newItem = {
                whole_name: item.whole_name,
              };
              item.shippingCompanyStatus.forEach((statusItem) => {
                newItem[statusItem.shipping_company] = statusItem.status_formal;
              });
              return newItem;
            });
          }
        }
        return file;
      } catch (err) {
        console.log("error [getWavePickingShippingCooperateList]", err);
      }
      return null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/wavepicking/ShippingRule/components/ShippingCooperate.vue